<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <v-row v-if="verUnidad">
      <v-col cols="12" v-if="componenteEvento.agregar_submodulo" class="d-flex justify-end">
        <ButtonComp @click="aggTema" textButton="Crear unidad" iconBut="fas fa-plus" normalButton />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <AutocompleteComp @change="filtroNivel(listNivel)" v-model="listNivel" textLabel="Nivel" :items="api_nivel"
          item-value="id_adm_nivel" item-text="nombre_nivel" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <AutocompleteComp @change="filtroGrados(listNivel, listGrado)" v-model="listGrado" textLabel="Grado"
          :items="api_grado" item-value="id_adm_grado" item-text="nombre_grado" :disabled="disabledGrado" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <AutocompleteComp @change="filtroArea(listGrado, listArea)" v-model="listArea" textLabel="Área" :items="api_area"
          item-value="id_adm_area" item-text="nombre_area" :disabled="disabledArea" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <AutocompleteComp @change="filtroCursos(listCurso)" v-model="listCurso" textLabel="Curso" :items="api_curso"
          item-value="id_adm_curso" item-text="nombre_curso" :disabled="disabledCurso" />
      </v-col>
      <v-col cols="12">
        <ComundataTablecomp :headers="GestionContenidosHeadersTema" :items="vis_tema" :search="search" whitSearch>

          <template v-slot:action_crear_clase="{ item }">
            <ButtonComp :loading="loadingVerTema.includes(item.id)" :disabled="loadingVerTema.includes(item.id)"
              @click="vistaClase(item)" tooltip-text="Ver temas" ver-button />
          </template>

          <template v-slot:action_editar="{ item }">
            <ButtonComp editButton @click="editTema(item)" tooltipText="Editar unidad" />
          </template>

          <template v-slot:action_borrar="{ item }">
            <ButtonComp @click="eventDeleteTema(item)" tooltipText="Eliminar unidad" deleteButton />
          </template>
        </ComundataTablecomp>
      </v-col>
    </v-row>


    <v-form ref="formTema" lazy-validation>
      <ComunDialogComp v-model="FormDialog" maxWidth="800" @close-modal="closeModalTema" :title="titleModalTema">
        <template v-slot:body>
          <v-row dense>
            <v-col cols="12" sm="12" md="6">
              <AutocompleteComp v-model="editedItem.id_nivel" :items="listTemaNivel" textLabel="Nivel"
                item-value="id_adm_nivel" item-text="nombre_nivel" @change="GetTemaGrado(editedItem.id_nivel)"
                :isDisable="disabledTemaNivel" :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <AutocompleteComp v-model="editedItem.id_grado" :items="listTemaGrado" textLabel="Grado"
                item-value="id_adm_grado" item-text="nombre_grado"
                @change="GetTemaArea(editedItem.id_nivel, editedItem.id_grado)" :isDisable="disabledTemaGrado"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <AutocompleteComp v-model="editedItem.id_area" :items="listTemaArea" textLabel="Área"
                item-value="id_adm_area" item-text="nombre_area"
                @change="GetTemaCurso(editedItem.id_grado, editedItem.id_area)" :isDisable="disabledTemaArea"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <AutocompleteComp v-model="editedItem.id_periodo" :items="listTemaPeriodo" textLabel="Periodo"
                item-value="id" item-text="nombre_periodo" :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <AutocompleteComp v-model="editedItem.id_curso" :items="listTemaCurso" textLabel="Curso"
                item-value="id_adm_curso" item-text="nombre_curso" :isDisable="disabledTemaCurso"
                :rules="validationRules.validateCampo" />
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-text-field v-model="editedItem.nombre_tema" label="Unidad"
                :rules="validationRules.validateCampo"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field v-model="editedItem.orden" label="Orden" type="number" min="0"
                @keypress="soloNumeros($event)"></v-text-field>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp :disabled="bloquearBotonGurdar" @click="updateTema(editedItem.id)" v-if="editar"
            textButton="Guardar cambios" iconBut="fas fa-save" normalButton />
          <ButtonComp :disabled="bloquearBotonGurdar" @click="addTema" v-if="agregar" textButton="Guardar"
            iconBut="fas fa-save" normalButton />
        </template>
      </ComunDialogComp>
    </v-form>

    <confirm @aceptar="deleteArchivo" @cancelar="clear_confirm" titleWindow="Eliminar tema" :title="confirm.title"
      :active="confirm.active" />

    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @actualizar="vistaClase"
      @close="CloseModal">
    </component>
  </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapActions, mapGetters } from "vuex";
import Tema from "../tema/tema.vue";
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import { GestionContenidosHeadersTema } from '../../../../helpers/headersTable';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import { validationRules } from '../../../../helpers/validatorHelpers';
export default {
  name: "Unidad",
  components: {
    Tema,
    AutocompleteComp,
    ButtonComp,
    ComunDialogComp,
    ComundataTablecomp
  },
  data() {
    return {
      verUnidad: true,
      ruta_api: API_URL,
      GestionContenidosHeadersTema,
      listNivel: "",
      listGrado: "",
      listArea: "",
      listCurso: "",

      vis_tema: [],
      api_nivel: [],
      api_grado: [],
      api_area: [],
      api_curso: [],

      listTemaNivel: [],
      listTemaGrado: [],
      listTemaArea: [],
      listTemaCurso: [],
      listTemaPeriodo: [],

      disabledGrado: true,
      disabledArea: true,
      disabledCurso: true,

      disabledTemaNivel: true,
      disabledTemaArea: true,
      disabledTemaCurso: true,
      disabledTemaGrado: true,

      paramsTemas: {
        id_usuario: sessionStorage.id,
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        nombre_tema: "",
        id_nivel: "",
        id_grado: "",
        id_area: "",
        id_curso: "",
        id_tema: "",
      },

      search: "",


      FormDialog: false,
      agregar: false,
      editar: false,
      editedItem: {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_periodo: null,
        orden: null,
        id_usuario: sessionStorage.id,
        fec_us_mod: null,
        estado_tema: 1,

        nombre_tema: "",
        id_nivel: 0,
        id_grado: null,
        id_area: null,
        id_curso: null,
        flag_malla_curricular: 1,
      },

      defaultaddtema:{
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_periodo: null,
        orden: null,
        id_usuario: sessionStorage.id,
        fec_us_mod: null,
        estado_tema: 1,

        nombre_tema: "",
        id_nivel: 0,
        id_grado: null,
        id_area: null,
        id_curso: null,
        flag_malla_curricular: 1,
      },
      
      confirm: {
        id: 0,
        title: "",
        active: false,
        procedencia: "",
      },
      api_vistaclase: {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_tema: null,
        estado_clase: 1,
      },

      compName: null,
      estadoComponente: true,
      parametroComp: [],

      bloquearBotonGurdar: false,
      loadingVerTema: [],
    };
  },
  computed: {
    ...mapGetters({
      componenteEvento: 'login/componenteEvento',
    }),
    titleModalTema() {
      return this.editar !== true ? "Crear unidad" : "Editar unidad";
    },

    validationRules() {
      return validationRules;
    }
  },
  mounted() {
    this.parametroComponente();
    this.getAllTemas();
    this.getNivel();
    // {id_submodulo:this.getSubmodulo.id_submodulo, id_modulo:this.getSubmodulo.id_modulo}
  },
  methods: {
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens"
    }),
    ...mapActions({
      parametroComponente: "login/parametroComponente",
    }),

    async getAllTemas() {
      try {
        let response = await axios.post("administrativo/tema/filt/ts/", this.paramsTemas);
        this.vis_tema = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    // actualizarParamentro() {

    // },
    async getNivel() {
      try {
        let params = {
          id_usuario: sessionStorage.id,
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
        };
        let response = await axios.post(
          "administrativo/nivel/filt/nc/contenido/",
          params
        );

        this.api_nivel = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async filtroNivel(id) {
      this.paramsTemas.id_nivel = id;
      this.paramsTemas.id_grado = "";
      this.paramsTemas.id_area = "";
      this.paramsTemas.id_curso = "";

      this.api_grado = [];
      this.api_area = [];
      this.api_curso = [];

      try {
        let params = {
          id_usuario: sessionStorage.id,
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_adm_nivel: id,
        };
        let response = await axios.post(
          "administrativo/grado/filt/gc/contenido/",
          params
        );

        this.api_grado = response.data;
        this.listArea = "";
        this.listCurso = "";
        this.getAllTemas();
        if (this.api_grado.length > 0) {
          this.disabledGrado = false;
          this.disabledArea = true;
          this.disabledCurso = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async filtroGrados(id_nivel, id_grado) {
      try {
        this.paramsTemas.id_area = "";
        this.paramsTemas.id_curso = "";
        this.paramsTemas.id_grado = id_grado;

        this.api_area = [];
        this.api_curso = [];

        this.listCurso = null;
        this.listArea = null;
        this.disabledCurso = true;
        await this.getAllTemas();

        // cargar Areas
        let params = {
          id_usuario: sessionStorage.id,
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_adm_nivel: id_nivel,
          id_adm_grado: id_grado,
        };

        let response = await axios.post(
          "/administrativo/area/filt/ac/contenido/",
          params
        );
        this.api_area = response.data;
        if (this.api_area.length > 0) {
          this.disabledArea = false;
        } else {
          this.disabledArea = true;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async filtroArea(id_grado, id_area) {
      this.paramsTemas.id_curso = "";
      this.paramsTemas.id_area = id_area;
      this.api_curso = [];
      try {
        let params = {
          id_usuario: sessionStorage.id,
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_adm_grado: id_grado,
          id_adm_area: id_area,
        };

        let response = await axios.post(
          "/administrativo/curso/filt/cc/contenido/",
          params
        );
        this.api_curso = response.data;
        if (this.api_curso.length > 0) {
          this.disabledCurso = false;
        } else {
          this.disabledCurso = true;
        }
        this.getAllTemas();
      } catch (e) {
        console.log(e);
      }
    },
    async filtroCursos(id) {
      this.paramsTemas.id_curso = id;
      await this.getAllTemas();
    },
    async loadQueryEdit(item) {
      try {
        let params = {
          id_colegio: item.id_colegio,
          id_ano_lectivo: item.id_ano_lectivo,
          id_usuario: item.id_us_ing,
          id_adm_nivel: item.id_adm_nivel,
          id_adm_grado: item.id_grado,
          id_adm_area: item.id_adm_area,
        };
        console.log("METHOD loadQueryEdit", params);

        let response01 = await axios.post(
          "administrativo/nivel/filt/nc/contenido/",
          params
        );
        this.listTemaNivel = response01.data;

        let response02 = await axios.post(
          "administrativo/grado/filt/gc/contenido/",
          params
        );
        this.listTemaGrado = response02.data;

        let response03 = await axios.post(
          "/administrativo/area/filt/ac/contenido/",
          params
        );
        this.listTemaArea = response03.data;

        let response04 = await axios.post(
          "/administrativo/curso/filt/cc/contenido/",
          params
        );
        this.listTemaCurso = response04.data;
        let response = await axios.post("administrativo/periodo/list/cp/", params);
        this.listTemaPeriodo = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getTemaNivel() {
      try {
        let params = {
          id_usuario: sessionStorage.id,
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
        };
        let response = await axios.post(
          "administrativo/nivel/filt/nc/contenido/",
          params
        );
        this.listTemaNivel = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    aggTema() {
      this.getTemaNivel();
      this.editedItem.orden = this.vis_tema.length + 1;
      this.disabledTemaNivel = false;
      this.FormDialog = true;
      this.agregar = true;
      this.editar = false;
      this.disabledTemaGrado = true;
      this.disabledGrado = true;
      this.disabledTemaArea = true;
      this.resetValidation();
    },
    async addTema() {
      if (this.$refs.formTema.validate()) {
        this.bloquearBotonGurdar = true;


        console.log('this.editedItem',this.editedItem);

        try {
          const response = await axios.post(`/administrativo/tema/`, this.editedItem);
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });


          if (response.data.error == 1) {
            this.bloquearBotonGurdar = false;

            
          } else {
            this.getAllTemas();
            this.dialog = false;
            this.editedItem = Object.assign({}, this.defaultaddtema);
            this.editedIndex === -1;
            //        this.agregar = true;
            this.disabledGrado = true;
            this.resetValidation();
            this.bloquearBotonGurdar = false;
          }

          this.FormDialog = false;
        } catch (error) {
          console.log(error);
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
          //  this.agregar = true;
          this.bloquearBotonGurdar = false;
        }
      }
    },
    editTema(item) {
      this.editedIndex = this.vis_tema.indexOf(item);
      // this.editedItem = Object.assign({}, item)
      this.editedItem.id = item.id;
      this.editedItem.id_colegio = item.id_colegio;
      this.editedItem.id_nivel = item.id_adm_nivel;
      this.editedItem.id_grado = item.id_grado;
      this.editedItem.id_area = item.id_adm_area;
      this.editedItem.id_periodo = item.id_periodo;
      this.editedItem.id_curso = item.id_curso;
      this.editedItem.nombre_tema = item.nombre_tema;
      this.editedItem.orden = item.orden;

      this.disabledTemaNivel = true;
      this.disabledTemaGrado = true;
      this.disabledTemaArea = true;
      this.disabledTemaCurso = true;
      this.editar = true;
      this.agregar = false;
      this.FormDialog = true;

      this.resetValidation();

      this.loadQueryEdit(item);
    },
    async updateTema(id) {
      this.bloquearBotonGurdar = true;
      try {
        let response = await axios.put(`/administrativo/tema/${id}`, this.editedItem);
        this.bloquearBotonGurdar = false;

        if (response.data.error == 1) {
          this.setEnviarMens({
            tipo: "E",
            mensaje: response.data.message,
            tiempo: null,
          });
        } else {
          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: null,
          });
          this.getAllTemas();
          this.closeModalTema();
        }
      } catch (error) {
        this.bloquearBotonGurdar = false;
        console.log(error);
      }
    },
    eventDeleteTema(item) {
      this.confirm.id = item.id;
      this.confirm.title = "¿Está seguro que eliminar este registro?";
      this.confirm.active = true;
      this.confirm.procedencia = "tema";
    },
    deleteArchivo() {
      this.deleteTema(this.confirm.id);
    },
    async deleteTema(id) {
      try {
        const resp = await axios.put(`/administrativo/tema/dt/inac/${id}`);
        this.getAllTemas();
        this.setEnviarMens({
          tipo: resp.data.messageT,
          mensaje: resp.data.message,
          tiempo: null,
        });
        this.clear_confirm();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        this.clear_confirm();
      }
    },
    async GetTemaGrado(id) {
      try {
        this.paramsTemas.id_pais = id;

        let params = {
          id_usuario: sessionStorage.id,
          id_colegio: sessionStorage.id_colegio,
          id_ano_lectivo: sessionStorage.id_ano_lectivo,
          id_adm_nivel: id,
        };

        let response = await axios.post(
          "administrativo/grado/filt/gc/contenido/",
          params
        );
        this.listTemaGrado = response.data;
        this.getAllPeriodos(id);
        //console.log(this.listTemaGrado)
        this.disabledTemaGrado = this.listTemaGrado.length > 0 ? false : true;
      } catch (e) {
        console.log(e);
      }
    },
    async GetTemaArea(id_nivel, id_grado) {
      let params = {
        id_usuario: sessionStorage.id,
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_adm_nivel: id_nivel,
        id_adm_grado: id_grado,
      };

      try {
        let response = await axios.post(
          "/administrativo/area/filt/ac/contenido/",
          params
        );
        this.listTemaArea = response.data;
        this.disabledTemaArea = this.listTemaArea.length > 0 ? false : true;
      } catch (e) {
        console.log(e);
      }
    },
    async GetTemaCurso(id_grado, id_area) {
      let paramsCurso = {
        id_usuario: sessionStorage.id,
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_adm_grado: id_grado,
        id_adm_area: id_area,
      };

      try {
        const response = await axios.post(
          "/administrativo/curso/filt/cc/contenido/",
          paramsCurso
        );
        this.listTemaCurso = response.data;
        this.disabledTemaCurso = this.listTemaCurso.length > 0 ? false : true;
      } catch (error) {
        console.log(error);
      }
    },
    async getAllPeriodos(id) {
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_adm_nivel: id,
      };
      try {
        let response = await axios.post("administrativo/periodo/list/cp/", params);
        this.listTemaPeriodo = response.data;
        if (this.listTemaPeriodo.length < 1) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `No hay periodos creados aún, no podrá crear temas`,
            tiempo: null,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    resetValidation() {
      this.$refs.formTema.resetValidation();
    },
    clear_confirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
      this.confirm.procedencia = "";
    },
    closeModalTema() {
      this.agregar = true;
      this.editar = false;
      this.FormDialog = false;
      this.editedItem = Object.assign({}, this.defaultaddtema);
      this.editedIndex === -1;
      this.disabledTemaCurso = true;
    },
    CloseModal() {
      this.verUnidad = true;
      this.estadoComponente = false;
    },

    async vistaClase(item) {

      this.loadingVerTema.push(item.id);
      try {
        this.api_vistaclase.id_tema = item.id;
        const response = await axios.post(
          "/administrativo/clase/listar/",
          this.api_vistaclase
        );

        setTimeout(async () => {
          this.loadingVerTema.splice(this.loadingVerTema.indexOf(item.id), 1);
          this.verUnidad = false;
          this.parametroComp = { evento: "view", item, clases: response.data };
          this.compName = "Tema";
          this.estadoComponente = true;
        }, 200);

      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

